import { SessionsAPI } from "../../session";

type ListParams = Parameters<typeof SessionsAPI.list_by_patient>[1];

export async function listPatientSessions(patientId: string, params?: ListParams) {
  const { data } = await SessionsAPI.list_by_patient(patientId, params);
  return data;
}

export async function listCoupleSessions(couplePatientId: string, params?: ListParams) {
  const { data } = await SessionsAPI.list_by_couple_patient(couplePatientId, params);
  return data;
}

export async function listGroupSessions(groupPatientId: string, params?: ListParams) {
  const { data } = await SessionsAPI.list_by_group_patient(groupPatientId, params);
  return data;
}

export async function deleteSession(id: string) {
  await SessionsAPI.delete(id);
}

export async function listSessionAgreements(sessionId: string) {
  const { data } = await SessionsAPI.getAgreements(sessionId);
  return data;
}

export async function createSessionAgreement(sessionId: string, text: string) {
  const { data } = await SessionsAPI.createAgreement(sessionId, text);
  return data;
}

export async function updateSessionAgreement(agreementId: string, changes: { text?: string; order?: number }) {
  const { data } = await SessionsAPI.updateAgreement(agreementId, changes);
  return data;
}

export async function deleteSessionAgreement(agreementId: string) {
  await SessionsAPI.deleteAgreement(agreementId);
}

export async function publishSessionAgreements(sessionId: string) {
  const { data } = await SessionsAPI.publishAgreements(sessionId);
  return data;
}
